import { render } from "./footer_main.vue?vue&type=template&id=066212bd&scoped=true&ts=true"
import script from "./footer_main.vue?vue&type=script&lang=ts"
export * from "./footer_main.vue?vue&type=script&lang=ts"

import "./footer_main.vue?vue&type=style&index=0&id=066212bd&lang=scss&scoped=true"

import exportComponent from "/home/newbaidev/public_html/projects-sit/uae/sit-ae-car.new.baidev.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-066212bd"]])

export default __exports__